<script setup>
  import { ref } from 'vue'

  defineProps(['id', 'name', 'value', 'label', 'parentClass'])

  const model = defineModel()

  const radioButtonRef = ref(null)
</script>

<template>
  <div class="form-radio" :class="parentClass">
    <RadioButton :id="id" v-bind="$attrs" ref="radioButtonRef" v-model="model" :value="value" />
    <label :for="id">
      <slot name="label">
        {{ $te(label) ? $t(label) : label }}
      </slot>
    </label>
  </div>
</template>

<style lang="scss" scoped>
  .form-radio {
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
